/* eslint-disable */

import 'jquery-ui/ui/widgets/droppable';
import 'jquery-ui/ui/widgets/draggable';
import i18n from 'i18next';
import data from './data';

require('jquery-ui-touch-punch');
require('../scss/style.scss');
require('../../../public/i18n');
/*
*    initilize ui controls. and register all events.
*/
const baseUrl = 'https://res.cloudinary.com/dodge7ws8/image/upload/core-interactives/grade-5/making-changes-ecosystem/layer/';

let period = 0;

function reset() {
    period = 0;
    $('.btn_main').html(i18n.t('IceAge.startSimulation'));
    $('.right_view').find('.mammoth, .squirrel, .img_human').remove();
    $('.left_view').find('.mammoth, .squirrel').css({ visibility: 'visible' });
    $('.btn_main').addClass('disable');
    $('.switch').removeClass('disable');
    $('.human :input').prop('disabled', false);
    $('.human :input').prop('selected', false);
    $('.period_bg, .period_image').hide();
    $(`.period_bg.img${period}`).show();
    $('.period').hide();
    $('.human :input').prop('checked', false);
}


function randomNumberFromRange(min, max) {
    return Math.floor(Math.random() * (max - min + 1) + min);
}

function die(object, killByHuman) {
    killByHuman = killByHuman || false;
    object.attr('death', 'true');
    if (object.hasClass('mammoth') && killByHuman) {
        object.attr('src', 'https://res.cloudinary.com/dodge7ws8/image/upload/v1524222212/core-interactives/grade-3/ice-age/G3_Ice_Age_Assets-30.png');
        object.addClass('animation_pop2S');
        setTimeout(() => {
            object.css({ width: '7em' });
            object.attr('src', 'https://res.cloudinary.com/dodge7ws8/image/upload/v1524222211/core-interactives/grade-3/ice-age/G3_Ice_Age_Assets-32.png');
            object.removeClass('animation_pop2S').addClass('animation_pop1S');
        }, 2000);
    } else {
        object.css({ width: '7em' });
        object.attr('src', 'https://res.cloudinary.com/dodge7ws8/image/upload/v1524222211/core-interactives/grade-3/ice-age/G3_Ice_Age_Assets-32.png');
        object.addClass('animation_pop1S');
    }
    object.css({ width: '7em' });
}

function addChild(object) {
    const child = object.clone();
    child.attr('lifeline', 80);
    const left = parseInt(child.css('left'), 10);
    if (left < 90) {
        child.css('left', `${left + 5}%`);
    } else {
        child.css('left', `${left - 5}%`);
    }
    $('.right_view').append(child);
    child.draggable();
    child.draggable('disable');
    child.addClass('animation_pop_in');
}

function initImages() {
    for (let i = 0; i < 6; i += 1) {
        $('.simulation_view').append(`<img class="period_bg img${i}" style="width: 100%; display: none;" src="https://res.cloudinary.com/dodge7ws8/image/upload/v1522136587/core-interactives/grade-3/ice-age/background/period-${i + 1}-background.png">`);
        $('.right_view').append(`<img class="period_image img${i}" display: none;" src="https://res.cloudinary.com/dodge7ws8/image/upload/core-interactives/grade-3/ice-age/G3_Ice_Age_Assets-${i + 9}.png">`);
    }
}

function isHumanEnable() {
    return $('.human').find('input').is(':checked');
}

function updateLifeLine(object) {
    let lifelineData = data.squirrel;
    if (object.hasClass('mammoth')) {
        lifelineData = isHumanEnable() ? data.mammoth2 : data.mammoth1;
    }
    const row = Math.floor(parseFloat(object[0].style.top.slice(0, -1)) / 4);
    const lifeline = parseInt(object.attr('lifeline'), 10) * lifelineData[row][period];
    object.attr('data-rowid', row);
    object.attr('lifeline', lifeline);
}

function toggleFullscreen(element) {
    const elem = element || document.documentElement;
    
    if (!document.fullscreenElement && !document.mozFullScreenElement
        && !document.webkitFullscreenElement && !document.msFullscreenElement) {
        if (elem.requestFullscreen) {
            elem.requestFullscreen();
        } else if (elem.msRequestFullscreen) {
            elem.msRequestFullscreen();
        } else if (elem.mozRequestFullScreen) {
            elem.mozRequestFullScreen();
        } else if (elem.webkitRequestFullscreen) {
            elem.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
        }
    } else {
        if (document.exitFullscreen) {
            document.exitFullscreen();
        } else if (document.msExitFullscreen) {
            document.msExitFullscreen();
        } else if (document.mozCancelFullScreen) {
            document.mozCancelFullScreen();
        } else if (document.webkitExitFullscreen) {
            document.webkitExitFullscreen();
        }
    }
}

const maxIcon = 'https://res.cloudinary.com/dodge7ws8/image/upload/core-interactives/shared/FullScreenWithBG.svg';
const minIcon = 'https://res.cloudinary.com/dodge7ws8/image/upload/core-interactives/shared/MinimiseWithBG.svg';

const fullScreenImg = $('<img style="cursor: pointer;">');
fullScreenImg.attr('src', document.fullscreenElement ? minIcon : maxIcon);

$('.fullscreen').append(fullScreenImg);

$('.fullscreen').click(() => {
    toggleFullscreen(document.getElementById('container'));
});

$(document).on('fullscreenchange webkitfullscreenchange mozfullscreenchange MSFullscreenChange', function() {
    if (document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement || document.msFullscreenElement) {
        fullScreenImg.attr('src', minIcon);
    } else {
        fullScreenImg.attr('src', maxIcon);
    }
});

function initCheckBox() {
    $('.human').find('input').change(() => {
        if (isHumanEnable()) {
            $('.right_view').append($('.img_human').clone().css({ top: '32.5%', left: '82.5%' }));
        } else {
            $('.right_view').find('.img_human').remove();
        }
    });
}

function initilizeRandomLifeLine() {
    $('.mammoth,.squirrel').each(function initLL() {
        const lifeline = Math.floor((Math.random() * 30) + 80);
        $(this).attr('lifeline', lifeline);
    });
}

function initObjects(type) {
    for (let i = 1; i <= 10; i += 1) {
        const objView = $('<div/>');
        objView.addClass('object');
        if (type === 'mammoth') {
            objView.html(
                '<img class=\'mammoth\' style=\'width: 7em; cursor: pointer; max-width: 92%;\' src=\'https://res.cloudinary.com/dodge7ws8/image/upload/v1522136449/core-interactives/grade-3/ice-age/G3_Ice_Age_Assets-29.png\' >',
            );
            $('.mammoth_container').append(objView);
        } else {
            objView.html('<img class=\'squirrel\' style=\'width: 4em; cursor: pointer; max-width: 55%;\' src=\'https://res.cloudinary.com/dodge7ws8/image/upload/v1522136441/core-interactives/grade-3/ice-age/G3_Ice_Age_Assets-28.png\' >');
            $('.squirrel_container').append(objView);
        }
        objView.find('img').draggable({
            revert: true,
            containment: $('.inner_container'),
        });
    }
}

function enableStartButton() {
    const elements = $('.left_view').find('.mammoth, .squirrel').filter(() => $(this).css('visibility') === 'visible');
    if (elements.length < 1) {
        $('.btn_main').removeClass('disable');
    }
}

function initDroppableZone() {
    $('.right_view').droppable({
        drop(event, ui) {
            if ($(ui.draggable).parent().hasClass('right_view')) {
                const top = ($(ui.draggable).position().top / $('.right_view').height()) * 100;
                const left = ($(ui.draggable).position().left / $('.right_view').width()) * 100;
                $(ui.draggable).css({
                    position: 'absolute', top: `${top}%`, left: `${left}%`, cursor: 'default',
                });
                return;
            }
            const clone = $(ui.draggable).clone();
            const top = (
                ($(ui.draggable).offset().top - $('.right_view').offset().top)
                / $('.right_view').height()) * 100;
            let left = (
                ($(ui.draggable).offset().left - $('.left_view').width() - $('.left_view').offset().left)
                / $('.right_view').width()) * 100;
            if (left > 93) {
                left = 93;
            }
            if (left < 0) {
                left = 0;
            }
            $(ui.draggable).css({ visibility: 'hidden' });
            clone.css({
                position: 'absolute', top: `${top}%`, left: `${left}%`, cursor: 'default',
            });
            clone.attr('data-top', top);
            clone.attr('clone', 'true');
            clone.draggable({
                revert: false,
                containment: $('.right_view'),
            });
            $('.right_view').append(clone);
            enableStartButton();
        },
    });
}

/*
*    this function is used to update layout of screen, maintain 16:9 ratio.
*/
function updateLayout() {
    let width = $(window).width();
    let height = $(window).height();
    if (height < 334) {
        height = 334;
    }
    if (width < 600) {
        width = 600;
    }
    $('#container').css({ height: `${height}px`, width: `${width}px` });
    if (height > width) {
        height = (720 / 1280) * width;
    } else if ((width / height) < 1.7) {
        height = (720 / 1280) * width;
    } else if ((width / height) > 1.778) {
        width = (1280 / 720) * height;
    }
    const top = ($('#container').height() - height) / 2;
    const left = ($('#container').width() - width) / 2;
    $('#container').css({ 'font-size': (`${width / 2160}em`) });
    $('.inner_container').css({
        top: `${top}px`, left: `${left}px`, height: `${height}px`, width: `${width}px`,
    });
}

function updatePeriod() {
    if (period > 5) {
        $('#reset_conform').show();
        return;
    }
    $('.human :input').prop('disabled', true);
    $('.switch').addClass('disable');
    $('.btn_main').html(period < 5 ? i18n.t('IceAge.nextPeriod') : i18n.t('IceAge.startOver'));

    $('.period').show();
    $('.right_view').find('.mammoth, .squirrel').draggable('disable');
    $('.period_level').html(i18n.t('IceAge.periodTime').replace('*TIME_PERIOD*', period + 1));
    $('.period_bg, .period_image').hide();
    $(`.period_bg.img${period}, .period_image.img${period}`).show();


    /* remove death icon */
    $('.right_view').find('.mammoth[death="true"], .squirrel[death="true"]').remove();

    /* period multiplier */
    $('.right_view').find('.mammoth, .squirrel').each(function updateLL() {
        updateLifeLine($(this));
    });

    /* birth phase */
    const noSquirrelChildPerRow = new Array(25).fill(0);
    let noMammothChild = 0;
    let noSquirrelChild = 0;

    let animation = 0;

    $('.right_view').find('.mammoth, .squirrel').each(function updateChild() {
        const object = $(this);
        if (object.attr('death') === 'true') {
            return;
        }
        if (parseInt(object.attr('lifeline'), 10) >= 130) {
            if (object.hasClass('mammoth') && noMammothChild < 1) {
                setTimeout(() => {
                    addChild(object);
                }, animation);
                animation += 2000;

                noMammothChild += 1;
            }
            const row = Math.floor(parseFloat(object[0].style.top.slice(0, -1)) / 4);
            if (object.hasClass('squirrel') && noSquirrelChild < 3 && noSquirrelChildPerRow[row] < 2) {
                setTimeout(() => {
                    addChild(object);
                }, animation);
                animation += 2000;

                noSquirrelChildPerRow[row] += 1;
                noSquirrelChild += 1;
            }
            object.attr('lifeline', 100);
        }
    });

    /* death phase */
    let counter = 0;
    $('.right_view').find('.mammoth, .squirrel').each(function updateDeath() {
        if ($(this).attr('death') === 'true') {
            return;
        }
        const object = $(this);
        const lifeline = parseInt(object.attr('lifeline'), 10);
        if (object.attr('death') !== 'true' && lifeline <= 20 && lifeline >= 0) {
            object.attr('death', 'true');
            const killByHuman = isHumanEnable() ? ((counter += 1) % 2 === 0) : false;
            const incrementTimeout = killByHuman ? 3000 : 1000;
            setTimeout(() => {
                die(object, killByHuman);
            }, animation);
            animation += incrementTimeout;
        }
    });

    /* migration phase */
    const sortedElement = $('.right_view').find('.mammoth, .squirrel').sort((a, b) => {
        const aTop = parseFloat($(a).css('top'), 10) / 4;
        const bTop = parseFloat($(b).css('top'), 10) / 4;
        if (aTop > bTop) {
            return 1;
        } if (aTop < bTop) {
            return -1;
        }
        return 0;
    });
    let noOfSquirrelMigrate = 0;
    let noOfMammothMigrate = 0;

    sortedElement.each(function updateMigrate() {
        const object = $(this);
        if (object.attr('death') === 'true') {
            return;
        }

        const lifeline = parseInt(object.attr('lifeline'), 10);
        if (lifeline < 0 && object.hasClass('mammoth')) {
            const migLimit = isHumanEnable() ? data.mammothMig2 : data.mammothMig1;
            if (noOfMammothMigrate < migLimit[period]) {
                const row = Math.floor(parseFloat(object[0].style.top.slice(0, -1)) / 4) + 1;

                let newRow = 0;
                if (row >= 11 && row <= 14) {
                    newRow = randomNumberFromRange(9, 10);
                } else if (row >= 15 && row <= 20) {
                    newRow = randomNumberFromRange(13, 14);
                } else if (row >= 21 && row <= 22) {
                    newRow = randomNumberFromRange(19, 20);
                } else if (row >= 23 && row <= 25) {
                    newRow = randomNumberFromRange(21, 22);
                } else {
                    const killByHuman = isHumanEnable() ? ((counter += 1) % 2 === 0) : false;
                    const incrementTimeout = killByHuman ? 3000 : 1000;
                    setTimeout(() => {
                        die(object, killByHuman);
                    }, animation);
                    animation += incrementTimeout;
                }
                if (newRow > 0) {
                    setTimeout(() => {
                        object.animate({ top: `${((newRow - 1) * 4) + 0.75}%` }, 1500);
                    }, animation);
                    animation += 1500;

                    object.attr('lifeline', '80');
                    noOfMammothMigrate += 1;
                }
            } else {
                const killByHuman = isHumanEnable() ? ((counter += 1) % 2 === 0) : false;
                const incrementTimeout = killByHuman ? 3000 : 1000;
                setTimeout(() => {
                    die(object, killByHuman);
                }, animation);
                animation += incrementTimeout;
            }
        } else if (lifeline < 0 && object.hasClass('squirrel')) {
            if (noOfSquirrelMigrate < data.squirrelMig[period]) {
                const row = Math.floor(parseFloat(object[0].style.top.slice(0, -1)) / 4) + 1;
                let newRow = 0;
                if (row >= 3 && row <= 4) {
                    newRow = randomNumberFromRange(1, 2);
                } else if (row === 5) {
                    newRow = randomNumberFromRange(2, 4);
                } else if (row >= 6 && row <= 7) {
                    newRow = randomNumberFromRange(3, 5);
                } else if (row >= 8 && row <= 10) {
                    newRow = randomNumberFromRange(6, 7);
                } else {
                    const incrementTimeout = 1000;
                    setTimeout(() => {
                        die(object, false);
                    }, animation);
                    animation += incrementTimeout;
                }
                if (newRow > 0) {
                    setTimeout(() => {
                        object.animate({ top: `${((newRow - 1) * 4) + 0.75}%` }, 1500);
                    }, animation);
                    animation += 1500;
                    object.attr('lifeline', '80');
                    noOfSquirrelMigrate += 1;
                }
            } else {
                const incrementTimeout = 1000;
                setTimeout(() => {
                    die(object, false);
                }, animation);
                animation += incrementTimeout;
            }
        }
    });
    $('.btn_main').addClass('disable');
    setTimeout(() => {
        $('.btn_main').removeClass('disable');
    }, animation);
    period += 1;
}

function initControls() {
    $('.inner_container').show();
    $('.simulation_view').show();
    $('.thumbnail_container').show();
    $('.welcome_screen').show();

    $(window).on('load', () => {
        $('.inner_container').css({ display: 'block' });
    });
    $('.btn_start').click(() => {
        $('.simulation_view').show();
        $('.welcome_screen').hide();
        $('.thumbnail_container').show();
    });
    $('.btn_main').click(() => {
        if (!$('.btn_main').hasClass('disable')) {
            updatePeriod();
        }
    });
    initImages();
    initCheckBox();
    initObjects('mammoth');
    initObjects('squirrel');
    initilizeRandomLifeLine();
    initDroppableZone();
    reset();
    
    $('#modal_reset_conform').click(() => {
        reset();
        $('#reset_conform').hide();
    });
    $('#modal_reset_no').click(() => {
        $('#reset_conform').hide();
    });
}

$(document).ready(() => {
    updateLayout();
    i18n.init();
    $(window).resize(() => {
        updateLayout();
    });
    initControls();

    $(document).mouseup((e) => {
        // if the target of the click isn't the container nor a descendant of the container
        const container = $('.help_text');
        if (!container.is(e.target) && container.has(e.target).length === 0) {
            container.hide();
        }
    });
    $('.common_menu').css({ width: '5em' });
});

window.setTimeout(() => {
    $('.inner_container').css({ display: 'block' });
}, 5000);
